"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Zoho = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#089949",
        d: "M10.718 14.8c-.183 0-.369-.038-.547-.116l-3.804-1.695a1.353 1.353 0 0 1-.684-1.783l1.695-3.804a1.353 1.353 0 0 1 1.782-.684l3.804 1.695c.68.301.987 1.103.685 1.782L11.954 14c-.226.504-.72.801-1.236.801Zm-.23-.829a.572.572 0 0 0 .753-.288l1.695-3.803a.573.573 0 0 0-.288-.754L8.842 7.431a.572.572 0 0 0-.753.288l-1.695 3.803a.572.572 0 0 0 .287.754l3.806 1.695Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#F9B21D",
        d: "M22.65 14.803h-4.165c-.744 0-1.35-.606-1.35-1.35V9.288c0-.744.605-1.35 1.35-1.35h4.165c.744 0 1.35.606 1.35 1.35v4.165c0 .744-.606 1.35-1.35 1.35Zm-4.165-6.086a.572.572 0 0 0-.57.57v4.165c0 .314.256.57.57.57h4.165c.314 0 .57-.256.57-.57V9.287a.572.572 0 0 0-.57-.57h-4.165Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#E42527",
        d: "m7.052 10.05-.56 1.256a.565.565 0 0 1-.022.038l.218 1.35a.57.57 0 0 1-.47.654l-4.113.666a.577.577 0 0 1-.426-.1.56.56 0 0 1-.228-.371L.785 9.43a.578.578 0 0 1 .1-.426.56.56 0 0 1 .37-.228l4.114-.665a.573.573 0 0 1 .654.473l.22 1.36.58-1.301-.03-.183a1.351 1.351 0 0 0-1.548-1.117l-4.112.665a1.323 1.323 0 0 0-.878.54 1.34 1.34 0 0 0-.237 1.005l.665 4.113A1.34 1.34 0 0 0 2.012 14.8c.071 0 .145-.005.218-.017l4.113-.665A1.351 1.351 0 0 0 7.46 12.57l-.408-2.52Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#226DB4",
        d: "m11.985 12.014.604-1.352-.172-1.258a.56.56 0 0 1 .112-.42.56.56 0 0 1 .378-.22l4.127-.56a.573.573 0 0 1 .423.112c.02.014.036.03.052.045a1.36 1.36 0 0 1 .692-.39 1.344 1.344 0 0 0-1.272-.542l-4.131.561a1.33 1.33 0 0 0-.892.52 1.344 1.344 0 0 0-.264 1l.343 2.504Zm7.023.696-.542-3.993a.57.57 0 0 0-.55.568v1.172l.321 2.359a.56.56 0 0 1-.111.42.56.56 0 0 1-.378.219l-4.127.56a.56.56 0 0 1-.421-.11.56.56 0 0 1-.219-.379l-.19-1.4-.604 1.353.022.152c.047.356.233.675.52.891a1.34 1.34 0 0 0 1.001.264l4.122-.556a1.33 1.33 0 0 0 .892-.52c.218-.289.311-.643.264-1Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m7.363 16.779.59-.87h-.485a.048.048 0 0 1-.048-.048v-.117c0-.026.022-.047.048-.047h.796c.026 0 .048.021.048.047v.046c0 .01-.003.019-.008.026l-.577.87h.518c.026 0 .048.021.048.047v.117a.048.048 0 0 1-.048.048h-.841a.048.048 0 0 1-.048-.048v-.043a.038.038 0 0 1 .007-.028Zm2.482-.49c0-.357.262-.614.618-.614.369 0 .618.252.618.616 0 .369-.254.623-.623.623-.37 0-.613-.255-.613-.625Zm.954.004c0-.216-.105-.401-.34-.401-.238 0-.329.192-.329.41 0 .208.112.398.34.398.236-.002.329-.204.329-.407Zm1.973-.599h.176c.026 0 .047.022.047.048v.442h.5v-.442c0-.026.021-.048.047-.048h.176c.026 0 .048.022.048.048v1.105a.048.048 0 0 1-.048.048h-.174a.048.048 0 0 1-.047-.047V16.4h-.5v.447a.048.048 0 0 1-.047.047h-.176a.048.048 0 0 1-.047-.047v-1.106a.044.044 0 0 1 .045-.048Zm2.636.595c0-.357.262-.614.618-.614.369 0 .618.252.618.616 0 .369-.254.623-.623.623-.37 0-.613-.255-.613-.625Zm.951.004c0-.216-.105-.401-.34-.401-.238 0-.328.192-.328.41 0 .208.111.398.34.398.236-.002.328-.204.328-.407Z"
      }
    )
  );
};
export default Zoho;
